import "./NotifyPop.css";
import { ToastContainer } from "react-toastify";

const NotifyPop = () => {
  return (
    <>
      <ToastContainer position="bottom-right" autoClose={1000} />
    </>
  );
};

export default NotifyPop;
